<template>
  <div class="orderlist">
    <div class="t-nav">
      <nav>
        <div class="r-title">
          <p><span>{{orderSimpleReport.orderCompleteCount}}</span>个已经完成 ，
            <span>{{orderSimpleReport.orderWaitPayCount}}</span>个待支付<i class="el-icon-caret-bottom"></i>
          </p>
        </div>
        <ul class="r-nav">
          <li :class="statusMenu[0].active"><a href="javascript:void(0)" @click="changeStatus('')">全部订单</a></li>
          <li :class="statusMenu[1].active"><a href="javascript:void(0)" @click="changeStatus('waitPay')">待支付</a></li>
          <li :class="statusMenu[2].active"><a href="javascript:void(0)" @click="changeStatus('producing')">生产中</a></li>
          <li :class="statusMenu[3].active"><a href="javascript:void(0)" @click="changeStatus('produced')">已完成</a></li>
          <li :class="statusMenu[4].active"><a href="javascript:void(0)" @click="changeStatus('expired')">已失效</a></li>
          <li :class="statusMenu[5].active"><a href="javascript:void(0)" @click="changeStatus('ftp')">FTP订单</a></li>
          <li :class="statusMenu[6].active"><a href="javascript:void(0)" @click="changeStatus('cloudDisk')">云盘订单</a>
          </li>
          <li :class="statusMenu[7].active"><a href="javascript:void(0)" @click="changeStatus('disk')">离线硬盘</a></li>
          <li :class="statusMenu[8].active"><a href="javascript:void(0)" @click="changeStatus('subscription')">周期订单</a>
          </li>
        </ul>
      </nav>
    </div>
    <div style="margin-top: 4px; width: 20%; height: 20px; margin-right: 0;">
      <el-input v-model="keyword" placeholder="请输入订单编号" clearable size="small" @input="search"></el-input>
    </div>

    <ul v-for="(item, index) in orders" :key="index">
      <citem :order="item"></citem>
    </ul>

    <div class="el-table__empty-block" v-show="orders.length===0">
      <span class="el-table__empty-text" v-loading="loading">暂无数据</span>
    </div>
    <div class="pages" v-if="total>pageSize">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="currentPage" :page-sizes="[5, 10, 15, 20]" :page-size="pageSize" background
        layout="sizes, prev, pager, next" :total="total">
      </el-pagination>
    </div>

  </div>
</template>
<script>
import eventBus from '../../common/eventBus.js'
import corderitem from '@/components/order/orderitem.vue'
export default {
  name: 'orders',
  props: ['orderStatus'],
  components: {
    'citem': corderitem
  },
  data () {
    return {
      soId: '',
      keyword: '',
      currentPage: 1,
      total: 0,
      pageSize: 5,
      orders: [],
      status: '',
      statusMenu: [
        {
          status: '',
          active: 'active'
        },
        {
          status: 'waitPay',
          active: ''
        },
        {
          status: 'producing',
          active: ''
        },
        {
          status: 'produced',
          active: ''
        },
        {
          status: 'expired',
          active: ''
        },
        {
          status: 'ftp',
          active: ''
        },
        {
          status: 'cloudDisk',
          active: ''
        },
        {
          status: 'disk',
          active: ''
        },
        {
          status: 'subscription',
          active: ''
        }
      ],
      loading: true,
      orderSimpleReport: {}
    }
  },
  created () {
    if (this.$route.params.soId) {
      this.statusMenu.forEach((item, index) => {
        if (item.status === 'subscription') {
          this.statusMenu[index].active = 'active'
        } else {
          this.statusMenu[index].active = ''
        }
      })
      this.soId = this.$route.params.soId
      this.$router.push({ name: 'dataOrders', params: { status: 'subscription' } })
      this.$emit('dataOrders')
      this.orderList(this.$route.params.soId, '')
    } else {
      if (this.$route.params.status) {
        this.status = this.$route.params.status
        this.changeStatus(this.status)
      } else {
        this.orderList('', '')
      }
    }
  },
  methods: {
    orderList (scheduleOrderId, code) {
      let orderType = 1
      if (this.$route.path === '/home/dataOrders') {
        orderType = 0
      }
      let queryParam = {
        orderType: orderType,
        status: this.status,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        scheduleOrderId: scheduleOrderId,
        code: code
      }
      this.sapost('/dmc/account/orders', queryParam, r => {
        this.loading = false
        let { retMsg, retCode, pager, orderSimpleReport } = r.data
        if (retCode === '0') {
          this.total = pager.total
          this.pageSize = pager.pageSize
          this.orders = pager.list
          this.orderSimpleReport = orderSimpleReport
        } else {
          if (retMsg === '用户未登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(retMsg)
        }
      })
    },
    changeStatus (status) {
      this.soId = ''
      this.statusMenu.forEach((item, index) => {
        if (item.status === status) {
          this.statusMenu[index].active = 'active'
        } else {
          this.statusMenu[index].active = ''
        }
      })
      this.status = status
      if (this.status !== this.orderStatus) {
        this.$emit('defaultActive', false)
      }
      this.$emit('topMenuStatus', this.status)
      this.orderList('', '')
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.orderList(this.soId, '')
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.orderList(this.soId, '')
    },
    search () {
      this.orderList('', this.keyword)
    }
  },
  watch: {
    orderStatus (val) {
      this.changeStatus(val)
    },
    $route () {
      this.orderList('', '')
    }
  }
}
</script>

<style lang="less" scoped>
.orderlist {
  margin-left: 200px;
  padding-left: 30px;
  background-color: #fff;
  .t-nav {
    nav {
      border-bottom: 2px solid #ddd;
      ul {
        margin-right: 150px;
        height: 60px;
        color: #b4b8bb;
        li {
          float: left;
          height: 60px;
          line-height: 60px;
          font-size: 15px;
          margin-right: 16px;

          a {
            color: #b4b8bb;
          }
        }
        li.active {
          border-bottom: 2px solid #f01400;
          a {
            color: #f01400;
          }
        }
        li:hover {
          border-bottom: 2px solid #f97575;
          a {
            color: #f97575;
          }
        }
      }
    }
  }
  .r-title {
    float: right;
    height: 60px;
    line-height: 60px;
    span {
      color: #f01400;
    }
  }
  .pages {
    text-align: right;
    padding-top: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/orderlist.vue